import PageContainer from '../page-container';
export default class AdimItemPageContainer extends PageContainer {
    fetchData(id) {
        this.fetchItem(id).then((result) => {
            if (result.error) {
                this.openPage(this.getBaseUrl());
            }
        });
    }
    componentWillMount() {
        this.fetchData(this.props.params.itemId);
    }
    componentWillReceiveProps(nextProps) {

        if (this.props.params.itemId !== nextProps.params.itemId) {
            this.fetchData(nextProps.params.itemId);
        }
    }

    onSuccessSubmit(wasNew, result) {
        if (wasNew) {
            this.openPage(`${this.getBaseUrl()}/${result.id}`);
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/admin/admin-item-page-container.js